<app-multiline-list [data]="data" (appInput)="input$$.next($event)" (appSelect)="select($event)"
	(appScrolled)="onScrolled()"></app-multiline-list>
